export default __webpack_public_path__ + "static/media/blackanddecker-icon.b0fddb8d.png";